// extracted by mini-css-extract-plugin
export default {"layout":"_9f9f9c58c2 _63937d6d8d _841414d400","h_slide":"_27ff0a46c4","category":"_33e63b35f8 _1c7d79d679 _24c6691af7"};